import { AIWriter } from "@virtual-brain-lib/frontend-ui";

export default function NotFound() {
	return (
		<div className="m-auto flex h-screen max-w-lg flex-col items-center justify-center p-8 text-center text-white">
			<AIWriter delay={100}>
				<div className="text-3xl font-bold">This page was not found 🧐</div>
				<div className="mt-2 text-xl">
					We couldn&apos;t find this page in our brains. Please check that you have access
					and try again.
				</div>
			</AIWriter>
		</div>
	);
}
